import { Button, Grid, TextField } from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useContext } from 'react'
import { GlobalContext } from '../../../App'
import { metodoPrograma } from '../../../components/api'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const retornaLocalAtendimento = (u = [], idLocalAtendimento) => ({
  idLocalAtendimento,
  idEspecialidade: u?.[0] || undefined,
  nmEspecialidade: u?.[1] || '',
})

const createAgenda = z.object({
  idEspecialidade: z.number().optional(),
  idLocalAtendimento: z.number(),
  nmEspecialidade: z.string().min(3, {
    message: 'Nome da especialidade inválido',
  }),
})

const Edicao = ({ dados, voltar }) => {
  const { localAtendimento } = useContext(GlobalContext)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createAgenda),
    defaultValues: retornaLocalAtendimento(dados, localAtendimento[0]),
  })
  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            {...register('nmEspecialidade')}
            label="Nome Especialidade"
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.nmEspecialidade}
            helperText={errors.nmEspecialidade?.message}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
